import React, { useCallback } from 'react'
import styles from './MultipleImages.module.css'
import Image from './Image'
export default function MultipleImages({images,singleImageClass,imageGroupName}) {

const Images = useCallback(
  () =>   {return images.map((n,index)=>{
    return <Image
   
    key={index}
    src={n.source}
    alt='alt'
    placeholder={ n.placeholder}
    className={ styles.image}
    fancybox={imageGroupName||'images'}
  
    // afterLoad={() => console.log('afterLoadText')}
    // beforeLoad={() => console.log('beforeLoadText')}
    />
    
   
  })},
  [images],
)

  
  return (
    <div className={styles.mutipleImageContainer}>
<Images/>
      
    </div>
  )
}
